module.exports = __webpack_public_path__ + "assets/img/back3.a6faaa35.png";